import { fade, makeStyles, Theme, createStyles } from '@material-ui/core/styles';

import { colors } from '../../styles';

export const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    appBar: {
      backgroundColor: colors.greyBrand,
      position: 'fixed',
    },
    badge: {
      color: colors.greyBg,
    },
    grow: {
      width: '100vw',
      zIndex: 999,
    },
    menuButton: {
      marginRight: theme.spacing(2),
    },
    menuItemText: {
      color: colors.white,
      cursor: 'pointer',
      fontFamily: 'Montserrat',
      fontSize: '13px',
      textTransform: 'uppercase',
      marginRight: '20px',
      [theme.breakpoints.up('md')]: {
        fontSize: '11px',
      },
    },
    title: {
      display: 'none',
      [theme.breakpoints.up('sm')]: {
        display: 'block',
      },
    },
    search: {
      color: colors.greyBg,
      position: 'relative',
      borderRadius: theme.shape.borderRadius,
      backgroundColor: fade(theme.palette.common.white, 0.15),
      '&:hover': {
        backgroundColor: fade(theme.palette.common.white, 0.25),
      },
      marginRight: theme.spacing(2),
      marginLeft: 0,
      width: '100%',
      [theme.breakpoints.up('sm')]: {
        marginLeft: theme.spacing(3),
        width: 'auto',
      },
    },
    searchIcon: {
      color: colors.greyBg,
      padding: theme.spacing(0, 2),
      height: '100%',
      position: 'absolute',
      pointerEvents: 'none',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
    },
    senslaLogo: {
      cursor: 'pointer',
      display: 'flex',
      minWidth: 120,
      width: '8%',
      justifyContent: 'center',
    },
    inputRoot: {
      color: 'inherit',
    },
    inputInput: {
      padding: theme.spacing(1, 1, 1, 0),
      // vertical padding + font size from searchIcon
      paddingLeft: `calc(1em + ${theme.spacing(4)}px)`,
      transition: theme.transitions.create('width'),
      width: '100%',
      [theme.breakpoints.up('md')]: {
        width: '20ch',
      },
    },
    sectionDesktop: {
      display: 'none',
      [theme.breakpoints.up('md')]: {
        display: 'flex',
      },
    },
    sectionMobile: {
      display: 'flex',
      [theme.breakpoints.up('md')]: {
        display: 'none',
      },
    },
  })
);
